/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerPromptQueryResponse, IncidentInvestigationControllerPromptPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerPrompt";

function getIncidentInvestigationControllerPromptUrl(id: IncidentInvestigationControllerPromptPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/incident-agent/investigations/${id}/prompt` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/prompt}
 */
export async function incidentInvestigationControllerPrompt(id: IncidentInvestigationControllerPromptPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerPromptQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentInvestigationControllerPromptUrl(id).url.toString(), ... requestConfig })  
  return res.data
}